// Heat cart drawer: the "add a second pair" button. Adds the frame through the same cart event
// Horizon's own add to bag uses, so the drawer, count and totals update in place.
import { CartLinesUpdateEvent } from '@shopify/events';

document.addEventListener('click', async (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-hx-cpair]') : null;
  if (!(button instanceof HTMLButtonElement) || button.disabled) return;
  button.disabled = true;

  const id = button.dataset.hxCpair;
  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((el) => (el instanceof HTMLElement ? el.dataset.sectionId : ''))
    .filter(Boolean);
  const deferred = CartLinesUpdateEvent.createPromise();
  button.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: id, quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const added = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: sectionIds.join(',') }),
    }).then((r) => r.json());
    if (added.status) throw new Error(added.description || added.message);
    const cart = await fetch('/cart.js').then((r) => r.json());
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source: 'hx-cart-pair', itemCount: 1, sections: added.sections, didError: false },
    });
  } catch (error) {
    deferred.reject(error);
    window.location.href = '/cart';
  }
});
